<template>
  <div>
    <div class="provider-info">
      <img src="../logos/godaddy-logo.svg">
    </div>
    <p>
      If you use GoDaddy as your email provider,
      you'll need to create an auto-forwarding rule
      from <strong>{{forwardingFromAddress}}</strong> to:
    </p>
    <clipboard-text :text="incomingEmailAddress" class="incoming-email-address" />
    <p><br></p>
    <p>There are two ways to auto-forward emails from GoDaddy:</p>
    <p><br></p>
    <ul>
      <li>
        To set up <strong>{{forwardingFromAddress}}</strong> as a forwarding address,
        <strong><a href="https://www.godaddy.com/help/set-up-my-forwarding-email-address-7598" target="_blank" class="just-a-link">follow
          these instructions</a></strong>.
      </li>
      <li>
        To forward a copy of incoming emails from <strong>{{forwardingFromAddress}}</strong> to this mailbox (while keeping a copy inside GoDaddy),
        <strong><a href="https://www.godaddy.com/help/forward-copies-of-my-incoming-email-8050" target="_blank" class="just-a-link">follow
          these instructions</a></strong>.
      </li>
    </ul>
    <p>
      When you've completed the steps provided by GoDaddy, click below to test that everything is working as expected.
    </p>
    <p><br></p>
    <dd-button
      :color="ColorAssistant.MailboxColor"
      size="large"
      full-width
      @click="$emit('completion-clicked')"
    >I've set up the auto-forwarding rule. Verify auto-forwarding is working!</dd-button>
  </div>
</template>
<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'MailboxVerificationInstructionsGoDaddy',
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  emits: ['completion-clicked'],
  data() {
    return {
      ColorAssistant,
      curSelection: '',
    }
  },
})
</script>

<style lang="scss">
// Shared from root mailbox-verification-auto-forwarding.vue
</style>
